import { handleActions } from 'redux-actions'

import { LOGIN, LOGOUT } from './constants'

const initialState = {
    user: null,
}

const handlers = {
    [LOGIN]: (state = initialState, action) => ({
        ...state,
        user: action.payload,
    }),
    [LOGOUT]: () => {
        localStorage.clear();
        return initialState
    }
}

export default handleActions(handlers, initialState);
